import { createSlice, PayloadAction } from "@reduxjs/toolkit";
const initialState = {
  manualTxnInvoiceId: "",
  manualInvoiceDueAmount: 0,
  type: "BILL" as "BILL" | "INVOICE",
};

export const LinkInkleInvoice = createSlice({
  name: "linkInkleInvoice",
  initialState: initialState,
  reducers: {
    setManualTransactionAdditionInvoice: (
      state,
      action: PayloadAction<{
        invoiceId: string;
        invoiceDueAmount: number;
        type: "BILL" | "INVOICE";
      }>
    ) => {
      state.manualTxnInvoiceId = action.payload.invoiceId;
      state.manualInvoiceDueAmount = action.payload.invoiceDueAmount;
      state.type = action.payload.type;
    },
  },
});

export const { setManualTransactionAdditionInvoice } = LinkInkleInvoice.actions;

export default LinkInkleInvoice.reducer;
